<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="阶段分化"
      :expand-all-row="true"
      :page="false"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.list"
      :show-reset="false"
      :setTable="true"
      table-title="信息列表"
      null-tip="当前考试暂无数据"
      :show-result="false"
      :custom-search="customSearch"
      @count="count"
      @search="search"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="入学年份">
          <el-select v-model="data.SchoolYear" size="mini" style="width:100%;" @change="reset" clearable>
            <el-option v-for="item in yearList" :key="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="当前考试名称" class="listLabel">
          <el-input v-model="params.ThisLvSn" size="mini" class="longInp" readonly @focus="onExamDialog(false)" placeholder="请选择考试"/>
        </el-form-item>
        <!-- <el-form-item label="入口考试名称" class="listLabel">
          <el-input v-model="params.EntryLvSn" size="mini" readonly @focus="onExamDialog(true)" class="entryInp" placeholder="请选择考试"/>
        </el-form-item> -->
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
    <el-table border size="small" :data="tableData" v-loading="loading">
      <el-table-column width="130">
        <template slot="header" slot-scope="{row}">
          <span @click="toDetails(row,null,null)" class="titleLink" v-if="Lvs.length" style="display:block;text-align:center;"><i class="el-icon-document-copy"></i></span>
        </template>
        <template slot-scope="{row,$index}">
          <span @click="toDetails(row,null,Lvs[$index].Sn)" class="titleLink">{{'中考'+(Lv1s.length>0?Lv1s[$index].LvName:'')}}</span>
        </template>
      </el-table-column>
      <template v-for="(item,index) in Lvs">
        <el-table-column min-width="140" :key="index">
          <template slot="header" slot-scope="{row}">
            <span @click="toDetails(row,Lvs[index].Sn,null)" class="titleLink">本次年级{{Lvs[index].LvName}}</span>
          </template>
          <template slot-scope="{row,$index}">
            <el-link v-if="row.a[index]>0" style="font-size:12px;" @click="toDetails(row,Lvs[index].Sn,Lv1s[$index].Sn)">{{row.a[index]}}</el-link>
            <span v-else>{{row.a[index]}}</span>
          </template>
        </el-table-column>
      </template>
      <!-- <el-table-column min-width="140">
        <template slot="header" slot-scope="{row}">
          <span @click="toDetails(row,Lvs[0].Sn,null)" class="titleLink">本次年级{{Lvs.length?Lvs[0].LvName:''}}</span>
        </template>
        <template slot-scope="{row,$index}">
          <el-link v-if="row.a>0" style="font-size:12px;" @click="toDetails(row,Lvs[0].Sn,Lv1s[$index].Sn)">{{row.a}}</el-link>
          <span v-else>{{row.a}}</span>
        </template>
      </el-table-column> -->
      <!-- <el-table-column min-width="150">
        <template slot="header" slot-scope="{row}">
          <span @click="toDetails(row,Lvs[1].Sn,null)" class="titleLink">本次年级{{Lvs.length?Lvs[1].LvName:''}}</span>
        </template>
        <template slot-scope="{row,$index}">
          <el-link v-if="row.b>0" style="font-size:12px;" @click="toDetails(row,Lvs[1].Sn,Lv1s[$index].Sn)">{{row.b}}</el-link>
          <span v-else>{{row.b}}</span>
        </template>
      </el-table-column>
      <el-table-column min-width="150">
        <template slot="header" slot-scope="{row}">
          <span @click="toDetails(row,Lvs[2].Sn,null)" class="titleLink">本次年级{{Lvs.length?Lvs[2].LvName:''}}</span>
        </template>
        <template slot-scope="{row,$index}">
          <el-link v-if="row.c>0" style="font-size:12px;" @click="toDetails(row,Lvs[2].Sn,Lv1s[$index].Sn)">{{row.c}}</el-link>
          <span v-else>{{row.c}}</span>
        </template>
      </el-table-column>
      <el-table-column min-width="150">
        <template slot="header" slot-scope="{row}">
          <span @click="toDetails(row,Lvs[3].Sn,null)" class="titleLink">本次年级{{Lvs.length?Lvs[3].LvName:''}}</span>
        </template>
        <template slot-scope="{row,$index}">
          <el-link v-if="row.d>0" style="font-size:12px;" @click="toDetails(row,Lvs[3].Sn,Lv1s[$index].Sn)">{{row.d}}</el-link>
          <span v-else>{{row.d}}</span>
        </template>
      </el-table-column>
      <el-table-column min-width="140">
        <template slot="header" slot-scope="{row}">
          <span @click="toDetails(row,Lvs[4].Sn,null)" class="titleLink">本次年级{{Lvs.length?Lvs[4].LvName:''}}</span>
        </template>
        <template slot-scope="{row,$index}">
          <el-link v-if="row.e>0" style="font-size:12px;" @click="toDetails(row,Lvs[4].Sn,Lv1s[$index].Sn)">{{row.e}}</el-link>
          <span v-else>{{row.e}}</span>
        </template>
      </el-table-column> -->
    </el-table>
    <exam-dialog ref="examDialog" in-dialog selectable :multiple="false" @select-multiple="setEntry" @select="setThis"></exam-dialog>
    <entry-dialog ref="entryDialog" @confirm="confirm"></entry-dialog>
    <search-dialog ref="searchDialog" @confirm="confirm2"></search-dialog>
    <list-dialog ref="listDialog" in-dialog></list-dialog>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import examDialog from "@/components/achieve/exam/listDialog";
import entryDialog from "./entryDialog";
import searchDialog from "./searchDialog";
import listDialog from "./listDialog";

export default {
  mixins: [listMixin],
  components: { 
    list,
    examDialog,
    entryDialog,
    searchDialog,
    listDialog
  },
  data() {
    return {
      api: require("@/api/analyse/analyse").default,
      examApi: require("@/api/achieve/exam").default,
      AnalyseId: null,
      params: {
        ThisLvSn: null,
        // EntryLvSn: null,
      },
      data: {
        // Entries: [],
        ThisExamId: null,
        SchoolYear: "",
        AnalyseType: 1,
      },
      // Entries: [],
      // EntryLvSn: "",
      table: [],
      Lvs: [],
      Lv1s: [],
      tableData: [],
      yearList: [],
      TermId: null,
      loading: false,
      searchParams: {},
      customSearch: [
        { bn: "统计", fn: 'count' },
        { bn: "查询", fn: 'search' },
      ]
    };
  },
  beforeMount() {
    this.examApi.getYear().then(res => {
      for (let i = res.Data.length-1; i > -1; i--) {
        this.yearList.push(res.Data[i])
      }
    })
  },
  methods: {
    getData() {
      this.getDataFunc()
    },
    onExamDialog(type) {
      if(!this.data.SchoolYear) {
        this.$message.error("请先选择入学年份")
        return
      }
      // if(!this.params.ThisLvSn&&type) {
      //   this.$message.error("请先选择当前考试")
      //   return
      // }
      this.$refs.examDialog.open().then((that) => {
        that.getData({ SchoolYear: this.data.SchoolYear, ExamType: 0 });
      });
    },
    setThis(exam) {
      this.TermId = exam.TermId;
      this.data.ThisExamId = exam.ExamId;
      this.params.ThisLvSn = exam.ExamCode;
    },
    setEntry(exam) {
      if(exam.length==0) {
        return
      }
      // this.Entries = [];
      // this.EntryLvSn = "";
      // exam.forEach(e => {
      //   this.Entries.push({
      //     EntryExamId: e.ExamId,
      //     EntryRatio: 0,
      //   })
      //   this.EntryLvSn += e.ExamCode + '，';
      // });
      this.openDialog(exam.length)
    },
    openDialog(num) {
      this.$refs.entryDialog.open();
      this.$refs.entryDialog.setData(num);
    },
    confirm(data) {
      this.Entries.forEach((e,index) => {
        e.EntryRatio = Number(data[index].ExamRatio)
      })
      // this.params.EntryLvSn = this.EntryLvSn;
      this.data.Entries = this.Entries;
      let obj = {
        SchoolYear: this.data.SchoolYear,
        Entries: this.data.Entries,
      }
      // console.log(obj)
    },
    confirm2(data) {
      this.loading = true;
      let obj = {
        ClassIds: data.ClassIds,
        AnalyseId:this.AnalyseId
      }
      if(data.type === 0) {
        obj.RecentTop5 = true;
      } else if(data.type === 1) {
        obj.Bad30 = true;
      } else  if(data.type === 2) {
        obj.Good30 = true;
      }
      this.searchParams = obj;
      this.api.filterAnalyse(obj).then(res => {
        this.loading = false;
        if(res.Code == 0) {
          this.AnalyseId = res.Data.AnalyseId;
          this.table = res.Data.Table;
          this.Lvs = res.Data.Lvs;
          this.Lv1s = res.Data.Lv1s;
          this.tableData = [];
          this.data.ThisExamId = res.Data.ThisExamId;
          this.table.forEach(e => {
            let obj = {};
            obj.a = [];
            e.forEach(n => {
              obj.a.push(n)
            })
            this.tableData.push(obj);
          })
        }
      })
    },
    getDataFunc() {
      this.api.getLastAnalyse(1).then(res => {
        this.AnalyseId = res.Data.AnalyseId;
        this.Lvs = res.Data.Lvs;
        this.Lv1s = res.Data.Lv1s;
        this.table = res.Data.Table;
        this.data.SchoolYear = res.Data.SchoolYear;
        this.data.ThisExamId = res.Data.ThisExamId;
        this.params.ThisLvSn = res.Data.ThisExamCode;
        this.TermId = res.Data.TermId;
        // this.table.forEach(e => {
        //   this.tableData.push({
        //     a: e[0],
        //     b: e[1],
        //     c: e[2],
        //     d: e[3],
        //     e: e[4],
        //   })
        // })
        this.table.forEach(e => {
          let obj = {};
          obj.a = [];
          e.forEach(n => {
            obj.a.push(n)
          })
          this.tableData.push(obj);
        })
      })
    },
    toDetails(row,ThisLvSn,EntryLvSn) {
      let obj = {
        AnalyseId: this.AnalyseId,
        ...this.searchParams
      }
      if(EntryLvSn != null) {
        obj.EntryLvSn = EntryLvSn;
      }
      if(ThisLvSn != null) {
        obj.ThisLvSn = ThisLvSn;
      }
      this.$refs.listDialog.open({ExamId: this.data.ThisExamId, type: 1, TermId: this.TermId}).then(that => {
        that.getData(obj)
      })
    },
    reset() {
      this.data.Entries = [];
      this.data.ThisExamId = null;
      this.params.ThisLvSn = "";
      // this.params.EntryLvSn = "";
      this.TermId = null;
    },
    count() {
      if(!this.data.ThisExamId) {
        this.$message.error("请先选择当前考试");
        return
      }
      this.loading = true;
      this.api.getAnalyse(this.data).then(res => {
        this.loading = false;
        if(res.Code == 0) {
          this.$refs.searchDialog.reset();
          this.searchParams = {};
          this.AnalyseId = res.Data.AnalyseId;
          this.tableData = [];
          this.Lvs = res.Data.Lvs;
          this.Lv1s = res.Data.Lv1s;
          this.table = res.Data.Table;
          this.data.ThisExamId = res.Data.ThisExamId;
          this.table.forEach(e => {
            let obj = {};
            obj.a = [];
            e.forEach(n => {
              obj.a.push(n)
            })
            this.tableData.push(obj);
          })
        } else {
          this.$message.error(res.Msg);
        }
      })
    },
    search() {
      if(!this.data.ThisExamId) {
        this.$message.error("请先选择当前考试");
        return
      }
      if(this.tableData.length==0) {
        this.$message.error("当前信息列表没有数据");
        return
      }
      this.$refs.searchDialog.open();
      this.$refs.searchDialog.setData(this.data.ThisExamId,this.TermId);
    },
    export() {
      if(!this.AnalyseId) {
        this.$message.warning("请先生成统计数据");
        return
      }
      if(this.searchParams.AnalyseId) {
        this.api.newExport(this.searchParams);
      } else {
        this.api.newExport({ AnalyseId: this.AnalyseId });
      }
      // this.api.export(this.AnalyseId)
    },
  },
};
</script>
<style lang="scss">
</style>